import { useLocalStorage } from 'usehooks-ts';

export function useTrustedDomains() {
    return useLocalStorage<string[]>('trustedDomains', [
        'https://gdladder.com',
        'https://pointercrate.com',
        'https://aredl.net',
    ]);
}
